import { render, staticRenderFns } from "./UsersDataTable.vue?vue&type=template&id=0f4c5008&scoped=true"
import script from "./UsersDataTable.vue?vue&type=script&lang=js"
export * from "./UsersDataTable.vue?vue&type=script&lang=js"
import style0 from "./UsersDataTable.vue?vue&type=style&index=0&id=0f4c5008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c5008",
  null
  
)

export default component.exports